import React from 'react';
import PropTypes from 'prop-types';
import SliderMUI from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Slider';

const Slider = ({
  className,
  onChange,
  value,
  marks,
  visibleLabelDisplay,
  valueLabelFormat,
  visibleMarks,
  visibleMarkLabels,
  ...rest
}) => {
  return (
    <SliderMUI
      className={className}
      value={value}
      step={1}
      marks={visibleMarkLabels ? marks : visibleMarks}
      valueLabelDisplay={visibleLabelDisplay ? 'on' : 'off'}
      valueLabelFormat={valueLabelFormat}
      onChange={onChange}
      min={1}
      max={marks.length}
      {...rest}
    />
  );
};

Slider.defaultProps = {
  className: '',
  visibleLabelDisplay: false,
  valueLabelFormat: value => value,
  visibleMarks: false,
  visibleMarkLabels: false,
};

Slider.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  marks: PropTypes.object.isRequired,
  visibleLabelDisplay: PropTypes.bool,
  valueLabelFormat: PropTypes.func,
  visibleMarks: PropTypes.bool,
  visibleMarkLabels: PropTypes.bool,
};

export default Slider;
